// production

export const publicPath = "/yjt_official_website";
export const apiPrefix = "https://yun.aitogo.cn/spot";

